// extracted by mini-css-extract-plugin
export default {"button":"basic_button__jMrYY","header":"basic_header__lPsn3","primary":"basic_primary__aBIWR","secondary":"basic_secondary__04Wka","disabled":"basic_disabled__LeSW0"};